const IMPACT_BADGE_STYLES = {
  high: "bg-light-grey text-status-red-danger",
  medium: "bg-light-grey text-status-orange",
  low: "bg-light-grey text-blue",
  watch: "bg-light-grey text-grey",
};

/**
 * Valorization-only panel: diagnostic (volume / sorting errors) + prioritized actions.
 */
const ValorizationRecommendationsSection = ({
  mainIssueMessages = [],
  recommendations = [],
  t,
  onOpenRecommendationsGuide = null,
}) => (
  <article className="statistics-card flex flex-col min-h-0 h-full">
    <div className="dashboard-chart-heading">
      <h5 className="dashboard-chart-title">
        {t("Issue and recommendations")}
      </h5>
      <p className="dashboard-chart-subtitle">
        {t("Valorization recommendations filter note")}
      </p>
    </div>

    <div className="statistics-callout mb-3">
      <p className="font-semibold mb-1">{t("Main issue")}</p>
      <ul className="space-y-2 list-none m-0 p-0">
        {mainIssueMessages.map((message, index) => (
          <li key={`main-issue-${index}`} className="text-sm">
            {message}
          </li>
        ))}
      </ul>
    </div>

    <div className="min-h-0 flex-1 overflow-y-auto">
      <p className="font-semibold mb-2">{t("Actions")}</p>
      <ul className="space-y-2 list-none m-0 p-0">
        {recommendations.map((action) => {
          const level = action.impactLevel || action.severity || "low";
          return (
            <li key={action.id || action.text} className="text-sm">
              - {action.text}{" "}
              <span
                className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ml-1 ${
                  IMPACT_BADGE_STYLES[level] ?? IMPACT_BADGE_STYLES.low
                }`}
              >
                {t(`Impact level.${level === "watch" ? "low" : level}`)}
              </span>
            </li>
          );
        })}
      </ul>
    </div>

    {typeof onOpenRecommendationsGuide === "function" ? (
      <div className="mt-3 shrink-0 border border-cyan bg-light-grey rounded-lg">
        <button
          type="button"
          onClick={onOpenRecommendationsGuide}
          className="w-full flex flex-row items-center justify-between gap-2 px-3 py-2 text-left bg-transparent border-0 cursor-pointer"
        >
          <span className="text-sm font-medium text-blue">
            {t("See how recommendations are calculated")}
          </span>
          <i className="fas fa-chevron-right text-xs text-blue" aria-hidden />
        </button>
      </div>
    ) : null}
  </article>
);

export default ValorizationRecommendationsSection;
